import { Timeslot } from '~types/appsync.types';
import { extractTime } from '~utils';

export const getHourFromTimeslot = (timeslot: Timeslot): number => {
  return parseInt(extractTime(timeslot.date).substring(0, 2), 10);
};
